// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ctCy","fullView":"styles_fullView__onR7F"};